import React from 'react';
import './TagBadge.scss';

export const enum TagBadgeType {
  GREEN = 'green',
  BLUE = 'blue',
  RED = 'red',
  GREY = 'grey',
  YELLOW = 'yellow',
  Normal = 'normal',
  EMPHASIS = 'emphasis',
}

type TagBadgeProps = {
  type: TagBadgeType;
  text?: string;
  icon?: string;
};
const TagBadge = (props: TagBadgeProps) => {
  const { type, icon, text } = props;
  return (
    <div className={`tag-badge ${type} ${icon ? 'with-icon' : ''} ${!text ? 'only-icon' : ''}`}>
      {icon && <img src={icon} alt="icon" className="tag-badge-icon" />}
      {text && <span className="tag-badge-text">{text}</span>}
    </div>
  );
};

export default TagBadge;
